<template>
	<div>
		<web-view :webview-styles="webviewStyles" :src="url"></web-view>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				webviewStyles: {
					progress: {
						color: '#FF3333'
					}
				},
				url:"",
			}
		},
		created() {
			
		    var url = options.url || '';
			if(url && url.indexOf("%")>=0)url=decodeURIComponent(url);
			this.url=url;
			
			//优先采用common_web_url
			var common_web_url=window.$utils.uniapi.getStorageSync("common_web_url")||"";
			if(!!common_web_url==true){
				uni.removeStorageSync("common_web_url");
				this.url=common_web_url;
			}
			console.log("=========",this.url,this.url.length);
			
			var title = options.title || '';
			if(!!title==true){
				uni.setNavigationBarTitle({ title:title })
			}else{
				uni.setNavigationBarTitle({ title:window.$config.appName });
			}
		},
		methods: {
		
		}
	}
</script>

<style scoped>
.xs {
		height: 100vh;
	}
</style>



// WEBPACK FOOTER //
// src/views/common/web.vue